import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials, type Testimonial } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';

// Los testimonios reales aún no existen: estas tarjetas quedan reservadas
// con el brief de lo que debe contar cada una. No se inventan reseñas.
const firstBatch: Testimonial[] = [{
  brief: 'Dinero con cifra concreta: una planner que dejó el «precio de amiga» y cerró su boda mejor pagada con los guiones del Tomo 2.',
  author: 'Nombre',
  role: 'Wedding Planner · Ciudad/País'
}, {
  brief: 'El visto resuelto: una planner que reactivó a una pareja que la había dejado en visto con el Protocolo Anti-Ghosting.',
  author: 'Nombre',
  role: 'Wedding Planner'
}, {
  brief: 'Estatus y reconocimiento: una planner que dejó de ser «la que ayuda con las bodas» y hoy la buscan por su nombre.',
  author: 'Nombre',
  role: 'Wedding Planner'
}];
const secondBatch: Testimonial[] = [{
  brief: 'Testimonio que nombre el Tomo 2 (Embudo de WhatsApp Gold) y cuente exactamente qué pasó después de usarlo.',
  author: 'Nombre',
  role: 'Wedding Planner'
}, {
  brief: 'Testimonio que nombre el Protocolo Anti-Ghosting y el resultado concreto que obtuvo con él.',
  author: 'Nombre',
  role: 'Wedding Planner'
}, {
  brief: 'Testimonio que nombre el Pack de Respuestas Anti-Regateo y cómo sostuvo su precio sin ceder.',
  author: 'Nombre',
  role: 'Wedding Planner'
}];
export function App() {
  return <div className="min-h-screen w-full bg-ivory text-ink font-sans selection:bg-gold selection:text-ink" data-id="element-0" data-mp="85l30vqb96bb">
      <MetaPixel data-id="element-1" data-mp="3gl4rzijy82kk" />
      <main data-id="element-2" data-mp="3gklag2y7ng72">
        <Hero data-id="element-3" data-mp="3gmfuzg5kl6am" />
        <SocialProofBar data-id="element-4" data-mp="3glwbhv09u9uh" />
        <Testimonials testimonials={firstBatch} background="white" data-id="element-5" data-mp="3gj1t090tiz3p" />
        <PainGrid data-id="element-6" data-mp="3bnuv5hu8comp" />
        <BigIdea data-id="element-7" data-mp="3bk70gfd1tw6e" />
        <ProductReveal data-id="element-8" data-mp="3qb7i9azor2f7" />
        <Tomes data-id="element-9" data-mp="3qbpl4qgusew3" />
        <Bonuses data-id="element-10" data-mp="3qc950cq2ddcr" />
        <Urgency data-id="element-11" data-mp="3qcqzb3t61hi1" />
        <Pricing data-id="element-12" data-mp="3qdajysa7ajzr" />
        <Transformation data-id="element-13" data-mp="3lkhf84eqfbno" />
        <Testimonials testimonials={secondBatch} title="Más planners que dejaron de improvisar" note="Los testimonios que citan una pieza específica del sistema convierten mucho más que los genéricos: pide que mencionen por nombre el Tomo 2, el Protocolo Anti-Ghosting o el Pack Anti-Regateo." background="ivory" data-id="element-14" data-mp="3lk7lq6uhamd8" />
        <Guarantee data-id="element-15" data-mp="18by986nrad12" />
        <Faq data-id="element-16" data-mp="1d47zjnss9f3v" />
        <CostOfInaction data-id="element-17" data-mp="1d4rdyuj85ld5" />
        <Close data-id="element-18" data-mp="1d62jaysbj16d" />
      </main>
      <Footer data-id="element-19" data-mp="1d6awysw9maim" />
    </div>;
}